import {
  Types,
  IAccessManagementState,
  ICustomerUser,
  ICustomerUserState
} from './types';
import { Reducer } from 'redux';
import { IUser } from '../user/types';

const INITIAL_STATE: IAccessManagementState = {
  customerUsers: [],
  loadingCreateCustomerUser: false,
  errorCreateCustomerUser: false,

  loadingRemoveUser: false,
  errorRemoveUser: false
};

type TCustomAction = {
  type: Types;
  payload: {
    customerId: string;
    users: IUser[];

    updatedUser: IUser;
  };
};

const reducer: Reducer<IAccessManagementState, TCustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.LOAD_CUSTOMER_USERS:
      return {
        ...state,
        customerUsers: updateCustomerUsers(
          action.payload.customerId,
          state.customerUsers,
          [],
          true,
          false
        )
      };
    case Types.LOAD_CUSTOMER_USERS_SUCCESS:
      return {
        ...state,
        customerUsers: updateCustomerUsers(
          action.payload.customerId,
          state.customerUsers,
          action.payload.users,
          false,
          false
        )
      };
    case Types.LOAD_CUSTOMER_USERS_FAILURE:
      return {
        ...state,
        customerUsers: updateCustomerUsers(
          action.payload.customerId,
          state.customerUsers,
          [],
          false,
          true
        )
      };

    case Types.CREATE_CUSTOMER_USER:
      return {
        ...state,
        loadingCreateCustomerUser: true,
        errorCreateCustomerUser: false,
        createCustomerUserMessage: undefined
      };
    case Types.CREATE_CUSTOMER_USER_SUCCESS:
      return {
        ...state,
        loadingCreateCustomerUser: false,
        errorCreateCustomerUser: false
      };
    case Types.CREATE_CUSTOMER_USER_FAILURE:
      return {
        ...state,
        loadingCreateCustomerUser: false,
        errorCreateCustomerUser: true
      };

    case Types.UPDATE_CUSTOMER_USER_PERMISSION:
      return {
        ...state,
        customerUsers: updateCustomerUserState(
          state.customerUsers,
          action.payload.customerId,
          action.payload.updatedUser,
          true,
          false
        )
      };
    case Types.UPDATE_CUSTOMER_USER_PERMISSION_SUCCESS:
      return {
        ...state,
        customerUsers: updateCustomerUserState(
          state.customerUsers,
          action.payload.customerId,
          action.payload.updatedUser,
          false,
          false
        )
      };
    case Types.UPDATE_CUSTOMER_USER_PERMISSION_FAILURE:
      return {
        ...state,
        customerUsers: updateCustomerUserState(
          state.customerUsers,
          action.payload.customerId,
          action.payload.updatedUser,
          false,
          true
        )
      };
    case Types.CLEAN_ERROR_FROM_CUSTOMER_USER:
      return {
        ...state,
        customerUsers: cleanErrorFromCustomerUser(
          state.customerUsers,
          action.payload.customerId,
          action.payload.updatedUser.id
        )
      };

    case Types.REMOVE_CUSTOMER_USER:
      return {
        ...state,
        loadingRemoveUser: true,
        errorRemoveUser: false
      };

    case Types.REMOVE_CUSTOMER_USER_SUCCESS:
      return {
        ...state,
        loadingRemoveUser: false
      };

    case Types.REMOVE_CUSTOMER_USER_FAILURE:
      return {
        ...state,
        loadingRemoveUser: false,
        errorRemoveUser: true
      };

    case Types.CLEAN_ERRORS:
      return {
        ...state,
        errorCreateCustomerUser: false,
        errorRemoveUser: false
      };

    default:
      return state;
  }
};

const updateCustomerUsers = (
  customerId: string,
  customerUsers: ICustomerUser[],
  users: IUser[],
  loadingUsers: boolean,
  errorUsers: boolean
): ICustomerUser[] => {
  const customerUserIdx = customerUsers.findIndex(
    (cu) => cu.customerId === customerId
  );
  if (customerUserIdx === -1) {
    customerUsers.push({
      customerId,
      users: users.map((user) => getCustomerUserState(user)),
      loadingUsers,
      errorUsers
    });
  } else {
    customerUsers[customerUserIdx] = {
      ...customerUsers[customerUserIdx],
      users: users.map((user) => getCustomerUserState(user)),
      loadingUsers,
      errorUsers
    };
  }

  return customerUsers;
};

const getCustomerUserState = (user: IUser): ICustomerUserState => {
  const customerUserState: ICustomerUserState = {
    ...user,
    loadingUpdateUser: false,
    errorUpdateUser: false
  };

  return customerUserState;
};

const updateCustomerUserState = (
  customerUsers: ICustomerUser[],
  customerId: string,
  user: IUser,
  loading: boolean,
  error: boolean
): ICustomerUser[] => {
  const updatedCustomerUser = customerUsers.find(
    (cu) => cu.customerId === customerId
  ) as ICustomerUser;

  const updatedUserIdx = updatedCustomerUser.users.findIndex(
    (ucu) => ucu.email === user.email
  );
  updatedCustomerUser.users[updatedUserIdx] = {
    ...user,
    loadingUpdateUser: loading,
    errorUpdateUser: error
  };

  return customerUsers;
};

const cleanErrorFromCustomerUser = (
  customerUsers: ICustomerUser[],
  customerId: string,
  userId: string
) => {
  const updatedCustomerUser = customerUsers.find(
    (cu) => cu.customerId === customerId
  ) as ICustomerUser;
  const updatedUserIdx = updatedCustomerUser.users.findIndex(
    (ucu) => ucu.id === userId
  );

  return updateCustomerUserState(
    customerUsers,
    customerId,
    updatedCustomerUser.users[updatedUserIdx],
    false,
    false
  );
};

export default reducer;
